import http from "./httpService";

const apiEndPoint = "/onboardingpresettings/";

export function getOnboardingPresettings() {
  return http.get(apiEndPoint);
}

export function updateOnboardingPresetting(id, payload) {
  return http.patch(`${apiEndPoint}${id}/`, payload);
}
